import { FeatureFlag } from '@ps/web-core-enums';
import { generatePath } from '@ps/web-core-utils';
import { isEmpty } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';

import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import { MainNav, PKR_CLUB_NAV_ID, useCheckUserClubRole, useHomeGamesWidget } from '@swf/poker';

import { ClubRoute, MemberRoute, UserClubRole } from '../../../types/common';
import type { NavLink } from '../../../types/common';

import {
  TXTCLI_Club_Lobby,
  TXTCLI_Club_Wall_1,
  TXTCLI_Members,
  TXTCLI_Results,
  TXTCLI_Standings
} from './ClubNav.messages.json';
import styles from './ClubNav.scss';

const ClubNav = () => {
  const { pathname } = useLocation();
  const { homeGamesClubs = '' } = useSelector(select.cms.getAliases);
  const { clubId } = useParams<{ clubId: string }>();
  const wallEnabled = useFeature(FeatureFlag.PKRHomeGamesTheWall);
  const { widgetSelect } = useHomeGamesWidget();
  const { clubNavHidden } = useSelector(widgetSelect.uiLayout);
  const { pending } = useSelector(widgetSelect.clubMembers);
  const isAdminOrManager = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Manager]);

  const links: NavLink[] = [
    {
      translation: TXTCLI_Club_Lobby,
      alias: 'homeGamesClubs',
      values: { clubId, section: ClubRoute.Lobby }
    },
    {
      translation: TXTCLI_Results,
      alias: 'homeGamesClubs',
      values: { clubId, section: ClubRoute.Results }
    },
    {
      translation: TXTCLI_Standings,
      alias: 'homeGamesClubs',
      values: { clubId, section: ClubRoute.Standings }
    },
    {
      active: pathname.includes(
        generatePath(homeGamesClubs, {
          clubId,
          section: ClubRoute.Members
        })
      ),
      translation: TXTCLI_Members,
      alias: 'homeGamesClubs',
      values: {
        clubId,
        section: ClubRoute.Members,
        subsection: isAdminOrManager ? MemberRoute.Pending : MemberRoute.List
      },
      notification: { visible: isAdminOrManager && !isEmpty(pending), content: '', variant: 'dot' }
    }
  ];

  if (wallEnabled) {
    links.splice(2, 0, {
      translation: TXTCLI_Club_Wall_1,
      alias: 'homeGamesClubs',
      values: { clubId, section: ClubRoute.Wall }
    });
  }

  return (
    <div id={PKR_CLUB_NAV_ID}>
      {!clubNavHidden && <MainNav links={links} innerClassName={styles.clubNav} />}
    </div>
  );
};

export default ClubNav;
